import React, { useEffect, useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material/';
import { LinearProgress, Stack } from '@mui/material';
import { toaster } from 'evergreen-ui';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import authentication from '../api/authentication';
import { signUpTemplate } from '../assets/templates';

const PrivateRoute = ({
  children,
  setUser,
}) => {
  const [userData, setUserData] = useState(signUpTemplate);
  const [isPasswordVisible, setIsPasswordVisible] = useState('password');
  const [isLoading, setIsLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [userID, setUserID] = useState(localStorage.getItem('id'));

  const handleSignUp = (e) => {
    e.preventDefault();
    document.getElementById('submit-button').classList.add('loading-button');
    setTimeout(async () => {
      setIsLoading(true);
      const signedUp = await authentication.signUp(userData);
      if (signedUp?.User?.createdAt) {
        const logedIn = await authentication.logIn(userData);
        if (logedIn?.token) {
          localStorage.setItem('token', logedIn.token);
          localStorage.setItem('id', logedIn.user);
          localStorage.setItem('user-name', logedIn.firstname);
          setUser(true);
          setIsLoading(false);
          setUserID(logedIn.user);
          toaster.success('Cuenta creada con exito', {
            id: 'forbidden-action',
            duration: 3,
          });
        } else {
          setIsLoading(false);
          document.getElementById('submit-button').classList.remove('loading-button');
          toaster.danger(logedIn?.message, {
            id: 'forbidden-action',
            duration: 3,
          });
        }
      } else {
        setIsLoading(false);
        document.getElementById('submit-button').classList.remove('loading-button');
        toaster.danger('Este usuario ya existe', {
          id: 'forbidden-action',
          duration: 3,
        });
      }
    }, 150);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    document.getElementById('submit-button').classList.add('loading-button');
    setTimeout(async () => {
      setIsLoading(true);
      const logedIn = await authentication.logIn({ email: userData.email, password: userData.password });
      if (logedIn?.token) {
        localStorage.setItem('token', logedIn.token);
        localStorage.setItem('id', logedIn.user);
        localStorage.setItem('user-name', logedIn.firstname);
        setUser(true);
        setIsLoading(false);
        setUserID(logedIn.user);
        toaster.success('Has iniciado sesion', {
          id: 'forbidden-action',
          duration: 3,
        });
      } else {
        setIsLoading(false);
        document.getElementById('submit-button').classList.remove('loading-button');
        toaster.danger(logedIn?.message, {
          id: 'forbidden-action',
          duration: 3,
        });
      }
    }, 150);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!showModal) {
        setShowModal(true);
      }
      clearTimeout(interval);
    }, 3500);

    return () => {
      clearTimeout(interval);
      setShowModal(false);
    };
  }, []);

  if (children) {
    return (
      <div role="none" onClick={() => !showModal && setShowModal(true)}>

        {(!userID) && (
        <div
          style={{
            width: '100%', height: '100%', zIndex: '1', position: 'absolute',
          }}
        >

          {showModal && (

            <div className="appear">
              {(!showLogin)
                ? (
                  <div className="signup-container auth-modal">
                    <form
                      style={{ boxShadow: '0px 0px 15px 5px #e5e5e5' }}
                      className="authentication-form"
                      onSubmit={(e) => handleSignUp(e)}
                    >
                      <label aria-label="userName" htmlFor="name">Nombre</label>
                      <input
                        className="select"
                        type="text"
                        id="name"
                        required
                        value={userData.firstname}
                        onChange={(e) => setUserData((prevState) => ({ ...prevState, firstname: e.target.value }))}
                      />
                      <label aria-label="userName" htmlFor="lastName">Apellido</label>
                      <input
                        className="select"
                        type="text"
                        id="lastName"
                        required
                        value={userData.lastname}
                        onChange={(e) => setUserData((prevState) => ({ ...prevState, lastname: e.target.value }))}
                      />
                      <label aria-label="userName" htmlFor="email">Correo</label>
                      <input
                        className="select"
                        type="email"
                        id="email"
                        required
                        value={userData.email}
                        onChange={(e) => setUserData((prevState) => ({ ...prevState, email: e.target.value }))}
                      />
                      <label aria-label="userName" htmlFor="password">Contraseña</label>
                      <div style={{ position: 'relative' }}>
                        <input
                          autoComplete="true"
                          className="select"
                          type={isPasswordVisible}
                          id="password"
                          required
                          value={userData.password}
                          onChange={(e) => setUserData((prevState) => ({ ...prevState, password: e.target.value }))}
                        />
                        <button
                          style={{ position: 'absolute' }}
                          className="password-button"
                          type="button"
                          onClick={() => {
                            if (isPasswordVisible === 'password') {
                              setIsPasswordVisible('text');
                            } else {
                              setIsPasswordVisible('password');
                            }
                          }}
                        >
                          {isPasswordVisible === 'password' ? <Visibility /> : <VisibilityOff />}
                        </button>
                      </div>
                      <div className="justify-align-items">
                        <p>¿Deseas recibir ofertas?</p>
                        <input
                          type="checkbox"
                          defaultChecked
                          onChange={(e) => setUserData((prevState) => ({
                            ...prevState, acceptOffers: e.target.checked,
                          }))}
                        />
                      </div>
                      {isLoading
                        ? (
                          <Stack sx={{ width: '200px', color: 'grey.500', margin: '33px 60px' }} spacing={2}>
                            <LinearProgress color="inherit" />
                          </Stack>
                        )
                        : (
                          <button onTransitionEnd={() => {}} id="submit-button" className="select-button" type="submit">
                            CREAR CUENTA
                          </button>
                        )}
                      <span
                        role="none"
                        type="button"
                        style={{ cursor: 'pointer', marginTop: '10px' }}
                        className="login-signup-link justify-items"
                        onClick={() => {
                          if (!isLoading) {
                            setUserData(signUpTemplate);
                            setShowLogin(true);
                          }
                        }}
                      >
                        ¿Ya tienes cuenta en Metior? Inicia sesion
                      </span>
                    </form>
                  </div>
                )
                : (
                  <div className="login-container auth-modal">
                    <form
                      style={{ boxShadow: '0px 0px 15px 5px #e5e5e5' }}
                      className="authentication-form"
                      onSubmit={(e) => handleLogin(e)}
                    >
                      <label aria-label="email" htmlFor="email">Correo</label>
                      <input
                        className="select"
                        type="text"
                        id="email"
                        required
                        value={userData.email}
                        onChange={(e) => setUserData((prevState) => ({ ...prevState, email: e.target.value }))}
                      />
                      <label aria-label="userName" htmlFor="password">Contraseña</label>
                      <div style={{ position: 'relative' }}>
                        <input
                          autoComplete="true"
                          className="select"
                          type={isPasswordVisible}
                          id="password"
                          required
                          value={userData.password}
                          onChange={(e) => setUserData((prevState) => ({ ...prevState, password: e.target.value }))}
                        />
                        <button
                          style={{ position: 'absolute' }}
                          className="password-button"
                          type="button"
                          onClick={() => {
                            if (isPasswordVisible === 'password') {
                              setIsPasswordVisible('text');
                            } else {
                              setIsPasswordVisible('password');
                            }
                          }}
                        >
                          {isPasswordVisible === 'password' ? <Visibility /> : <VisibilityOff />}
                        </button>
                      </div>
                      {isLoading
                        ? (
                          <Stack sx={{ width: '200px', color: 'grey.500', margin: '33px 60px' }} spacing={2}>
                            <LinearProgress color="inherit" />
                          </Stack>
                        )
                        : (
                          <button onTransitionEnd={() => {}} id="submit-button" className="select-button" type="submit">
                            INICIAR SESION
                          </button>
                        )}
                      <span
                        role="none"
                        type="button"
                        style={{ cursor: 'pointer', marginTop: '10px' }}
                        className="login-signup-link justify-items"
                        onClick={() => {
                          if (!isLoading) {
                            setUserData(signUpTemplate);
                            setShowLogin(false);
                          }
                        }}
                      >
                        ¿Eres nuevo en Metior? Crea una cuenta
                      </span>
                    </form>
                  </div>
                )}
            </div>
          )}
        </div>
        )}
        {children}
      </div>
    );
  }

  return <p style={{ margin: '30px', textAlign: 'center' }}>Cargando...</p>;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  setUser: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setUser: (values) => dispatch({
    type: 'SET_USER',
    payload: values,
  }),
});

export default connect(null, mapDispatchToProps)(PrivateRoute);
